const style = {
    loginBox: {
        display: 'flex',
        width: '250px',
        padding: '20px',
        textAlign: 'center'
    },
    textField: {
        width: '100%',
        height: '56px',
        backgroundColor: '#f1f1f1',
        color: '#19191d',
        marginTop: '0',
        marginBottom: '20px',
        marginLeft: '0',
        borderRadius: '6px'
    },
    loginButton: {
        color: '#2f3192',
        width: '130px',
        height: '40px',
        backgroundColor: '#ffffff'
    },
}

export default style;